import { render, staticRenderFns } from "./SidebarStyle.vue?vue&type=template&id=1a92f6e6"
import script from "./SidebarStyle.vue?vue&type=script&lang=js"
export * from "./SidebarStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports